
import useAccount from "@/composables/useAccount";
import { Customer } from "@/models/www/store/User";
import useVuelidate from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";
import { defineComponent, PropType, reactive, ref } from "vue";
import AccountSetting from "./AccountSetting.vue";
import AccountSettingsSection from "./AccountSettingsSection.vue";
import { UserType } from "@/models/enums";

export default defineComponent({
	components: { AccountSettingsSection, AccountSetting },
	props: {
		customer: {
			type: Object as PropType<Customer>,
			required: true,
		},
	},
	setup(props) {
		const { updateCustomer } = useAccount();
		const loading = ref(false);
		const settingsSectionRef = ref();

		const state = reactive({
			email: props.customer.email,
			phone: props.customer.phone,
		});

		const rules = {
			email: {
				required,
				email,
			},
			phone: {},
		};

		const v$ = useVuelidate(rules, state);

		const submit = async () => {
			const valid = await v$.value.$validate();
			if (valid) {
				loading.value = true;
				updateCustomer({
					...props.customer,
					...{
						mobilePhone: state.phone,
						email: state.email,
					},
				})
					.then(() => settingsSectionRef.value.toggle())
					.finally(() => (loading.value = false));
			}
		};

		return { v$, loading, submit, settingsSectionRef, UserType };
	},
});
